<template>
    <p>
        Test Page.
        <br>
        {{showNavBar}}
    </p>
</template>
<script>
    import userInfo from "../store/userInfo";

    export default {
        store: userInfo,
        mounted() {
            userInfo.commit('showNavBar');
        },
        computed: {
            showNavBar() {
                return this.$store.getters.getShowNavBar;
            }
        }
    }
</script>